import { render, staticRenderFns } from "./FaultEventAlarm.vue?vue&type=template&id=72cdf75a&scoped=true"
import script from "./FaultEventAlarm.vue?vue&type=script&lang=ts"
export * from "./FaultEventAlarm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cdf75a",
  null
  
)

export default component.exports